import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { id: "g-modal-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalWindows, (window) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(window.windowType), _mergeProps({
                key: window.id,
                ref_for: true
            }, window.windowAttrs), {
                default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(window.component), _mergeProps({ ref_for: true }, window.componentAttrs), null, 16))
                ]),
                _: 2
            }, 1040));
        }), 128))
    ]));
}
